import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { PluggableList } from "unified";

// GFM: research answers lean on tables, which core markdown renders as raw pipes.
const REMARK_PLUGINS: PluggableList = [remarkGfm];

// The message part sets size and colour; prose adds headings, lists and tables.
const PROSE =
  "prose prose-sm max-w-none text-ink prose-headings:text-ink prose-strong:text-ink prose-a:text-ink";

/** An assistant answer's markdown, as the body of a v2 ChatAssistantMessage. */
export function AnswerMarkdown({
  text,
  rehypePlugins,
}: {
  text: string;
  rehypePlugins?: PluggableList;
}) {
  return (
    <div className={PROSE}>
      <Markdown remarkPlugins={REMARK_PLUGINS} rehypePlugins={rehypePlugins}>
        {text}
      </Markdown>
    </div>
  );
}
